import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=258d8ec8&scoped=true"
var script = {}
import style0 from "./ModalView.vue?vue&type=style&index=0&id=258d8ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258d8ec8",
  null
  
)

export default component.exports